export default __webpack_public_path__ + "static/media/move-material-5.7c148ccc.webp";